import { useEffect, useRef, useState } from "react";

/** Keep fast requests visually quiet; action guards still use the immediate pending state. */
export function useDelayedPending(pending: boolean, delayMs = 300, minimumVisibleMs = 0): boolean {
  const [visible, setVisible] = useState(false);
  const shownAt = useRef<number | null>(null);
  useEffect(() => {
    if (!pending) {
      const remaining =
        shownAt.current === null ? 0 : minimumVisibleMs - (Date.now() - shownAt.current);
      if (remaining > 0) {
        const timer = window.setTimeout(() => {
          shownAt.current = null;
          setVisible(false);
        }, remaining);
        return () => window.clearTimeout(timer);
      }
      shownAt.current = null;
      setVisible(false);
      return;
    }
    if (shownAt.current !== null) return;
    if (delayMs === 0) {
      shownAt.current = Date.now();
      setVisible(true);
      return;
    }
    const timer = window.setTimeout(() => {
      shownAt.current = Date.now();
      setVisible(true);
    }, delayMs);
    return () => window.clearTimeout(timer);
  }, [pending, delayMs, minimumVisibleMs]);
  return (pending || minimumVisibleMs > 0) && visible;
}
